import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const points = ['Te esfuerzas, trabajas, intentas — pero la vida que imaginaste todavía no llega.', 'Por dentro sabes que mereces más: más paz, más dinero, más amor, más propósito. Pero no sabes qué está fallando.', 'Cada vez que estás a punto de dar el paso que cambia todo, aparece el miedo. Y te quedas donde estás.', 'Has probado técnicas, leído libros, escuchado podcasts — pero algo sigue sintiéndose incompleto.', 'Sientes un vacío difícil de explicar. Como si la vida pasara y tú la vieras desde afuera, esperando tu turno que nunca termina de llegar.', 'Hay una voz dentro de ti que susurra: "Esto no es todo lo que hay para mí." Y esa voz tiene razón.'];
export function PainPoints() {
  return <section className="py-20 px-4 bg-white/40" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-194">
          <span className="text-4xl mb-4 block" data-id="element-195">🪞</span>
          <h2 className="text-3xl md:text-4xl font-bold text-balance mb-6" data-id="element-196">
            Dime... ¿Cuántas de Estas Frases Describen Cómo Te Sientes?
          </h2>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-197">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-brand-rose/10" data-id="element-198">
              <Star className="w-6 h-6 text-brand-gold shrink-0 mt-1 fill-brand-gold/20" data-id="element-199" />
              <p className="text-lg text-brand-textLight leading-relaxed" data-id="element-200">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-6 text-lg md:text-xl text-brand-text max-w-3xl mx-auto" data-id="element-201">
          <p className="font-medium" data-id="element-202">
            Si te reconociste en alguna de estas frases, lo que vas a leer puede
            ser el antes y el después de tu vida.
          </p>
          <p data-id="element-203">Porque lo que sientes no es debilidad.</p>
          <p data-id="element-204">No es falta de esfuerzo ni de voluntad.</p>
          <p className="text-brand-plum font-semibold text-xl md:text-2xl" data-id="element-205">
            Es que nadie te enseñó a trabajar con la parte de tu mente que
            realmente controla tu realidad.
          </p>
          <p data-id="element-206">
            Y eso — exactamente eso — es lo que la Abu Aurora descubrió después
            de 35 años de estudio y transformación profunda.
          </p>
        </motion.div>
      </div>
    </section>;
}